import { useEffect } from 'react';
import amplitudeManager from 'javascripts/services/amplitude-manager';
import { useCurrentUser } from 'javascripts/hooks';

export function AmplitudeProvider({ children }: { children: React.ReactNode }) {
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (Object.keys(currentUser).length !== 0) {
      amplitudeManager.initialize(currentUser);
    }
  }, [currentUser]);

  return children;
}
